var Backbone, EmailFormIntlBaseDateInputView, EmailFormIntlDateTimeInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormIntlBaseDateInputView = require("./base_date_input_view.coffee");

Backbone = require('backbone');

Backbone.$ = $;

EmailFormIntlDateTimeInputView = (function(superClass) {
  extend(EmailFormIntlDateTimeInputView, superClass);

  function EmailFormIntlDateTimeInputView() {
    return EmailFormIntlDateTimeInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlDateTimeInputView.prototype.tagName = 'li';

  EmailFormIntlDateTimeInputView.prototype.events = {
    'change .date_time_input': 'validateEmailForm',
    'keydown .date_time_input': 'deleteKeyDownHandler'
  };

  EmailFormIntlDateTimeInputView.prototype.initialize = function() {
    var ref;
    EmailFormIntlBaseDateInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".date_time_input";
    this.show_template = {
      date_time_input_template: true
    };
    if (((ref = this.model.additional_attributes) != null ? ref.options : void 0) != null) {
      return this.dropdownOptions = this.getDropdownOptions(this.model.additional_attributes.options);
    }
  };

  EmailFormIntlDateTimeInputView.prototype.getDropdownOptions = function(options) {
    var dropdownOptions, i, len, option;
    dropdownOptions = [];
    for (i = 0, len = options.length; i < len; i++) {
      option = options[i];
      dropdownOptions.push({
        id: option,
        text: option
      });
    }
    return dropdownOptions;
  };

  EmailFormIntlDateTimeInputView.prototype.getTimeSlotInputHtmlElement = function() {
    return this.$el.find(".time_slot option:selected");
  };

  EmailFormIntlDateTimeInputView.prototype.readInput = function() {
    var date, slot;
    date = this.getInputHtmlElement().val().trim();
    slot = this.getTimeSlotInputHtmlElement().text();
    return date + " - " + slot;
  };

  return EmailFormIntlDateTimeInputView;

})(EmailFormIntlBaseDateInputView);

module.exports = EmailFormIntlDateTimeInputView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9JTlRML2RhdGVfdGltZV9pbnB1dC5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9lbWFpbF9mb3JtL0lOVEwvZGF0ZV90aW1lX2lucHV0LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLHdFQUFBO0VBQUE7OztBQUFBLDhCQUFBLEdBQWlDLE9BQUEsQ0FBUSwrQkFBUjs7QUFDakMsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBRVA7Ozs7Ozs7MkNBQ0osT0FBQSxHQUFTOzsyQ0FFVCxNQUFBLEdBQ0U7SUFBQSx5QkFBQSxFQUEyQixtQkFBM0I7SUFDQSwwQkFBQSxFQUE2QixzQkFEN0I7OzsyQ0FHRixVQUFBLEdBQVksU0FBQTtBQUNWLFFBQUE7SUFBQSw4QkFBOEIsQ0FBQSxTQUFFLENBQUEsVUFBVSxDQUFDLEtBQTNDLENBQWlELElBQWpELEVBQXVELFNBQXZEO0lBQ0EsSUFBQyxDQUFBLFNBQUQsR0FBYTtJQUNiLElBQUMsQ0FBQSxhQUFELEdBQWlCO01BQUMsd0JBQUEsRUFBMEIsSUFBM0I7O0lBQ2pCLElBQWdGLGlGQUFoRjthQUFBLElBQUMsQ0FBQSxlQUFELEdBQW1CLElBQUMsQ0FBQSxrQkFBRCxDQUFvQixJQUFDLENBQUEsS0FBSyxDQUFDLHFCQUFxQixDQUFDLE9BQWpELEVBQW5COztFQUpVOzsyQ0FNWixrQkFBQSxHQUFvQixTQUFDLE9BQUQ7QUFDbEIsUUFBQTtJQUFBLGVBQUEsR0FBa0I7QUFDbEIsU0FBQSx5Q0FBQTs7TUFDRSxlQUFlLENBQUMsSUFBaEIsQ0FBcUI7UUFBQyxFQUFBLEVBQUksTUFBTDtRQUFhLElBQUEsRUFBTSxNQUFuQjtPQUFyQjtBQURGO1dBRUE7RUFKa0I7OzJDQU1wQiwyQkFBQSxHQUE2QixTQUFBO1dBQzNCLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLDRCQUFWO0VBRDJCOzsyQ0FHN0IsU0FBQSxHQUFXLFNBQUE7QUFDVCxRQUFBO0lBQUEsSUFBQSxHQUFPLElBQUMsQ0FBQSxtQkFBRCxDQUFBLENBQXNCLENBQUMsR0FBdkIsQ0FBQSxDQUE0QixDQUFDLElBQTdCLENBQUE7SUFDUCxJQUFBLEdBQU8sSUFBQyxDQUFBLDJCQUFELENBQUEsQ0FBOEIsQ0FBQyxJQUEvQixDQUFBO1dBQ0osSUFBRCxHQUFNLEtBQU4sR0FBVztFQUhKOzs7O0dBdEJnQzs7QUEyQjdDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
